import { render, staticRenderFns } from "./clipboard_button.vue?vue&type=template&id=0b085e0a&"
import script from "./clipboard_button.vue?vue&type=script&lang=js&"
export * from "./clipboard_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "clipboard_button.vue"
export default component.exports